import { joinClasses } from "ui";
import styles from "./css/AboutParagraph.module.css";

export function AboutParagraph({
  children,
  className = "",
  style = {},
}: {
  children: any;
  className?: string;
  style?: { [key: string]: any };
}) {
  return (
    <div
      className={joinClasses(styles.paragraph, styles.bodyText, className)}
      style={style}
    >
      {children}
    </div>
  );
}
